const MS_PER_DAY = 3600 * 1000 * 24;

/** 与素材管理-图片日期范围一致的快捷选项 */
const DATE_RANGE_SHORTCUT_DEFS = [
  { text: '最近一周', days: 7 },
  { text: '最近半个月', days: 15 },
  { text: '最近一个月', days: 30 },
  { text: '最近两个月', days: 60 },
  { text: '最近三个月', days: 90 },
  { text: '最近半年', days: 180 },
  { text: '最近一年', days: 365 }
];

/**
 * 创建 el-date-picker(daterange) 的 picker-options
 * @param {{ excludeToday?: boolean }} [options]
 * excludeToday=true 时结束日为昨天，并禁用今天及以后（报表类页面）
 */
export function createDateRangePickerOptions(options = {}) {
  const excludeToday = !!options.excludeToday;

  const pickerOptions = {
    shortcuts: DATE_RANGE_SHORTCUT_DEFS.map(({ text, days }) => ({
      text,
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        if (excludeToday) {
          end.setTime(end.getTime() - MS_PER_DAY);
          start.setTime(start.getTime() - MS_PER_DAY * days);
        } else {
          start.setTime(end.getTime() - MS_PER_DAY * days);
        }
        picker.$emit('pick', [start, end]);
      }
    }))
  };

  if (excludeToday) {
    pickerOptions.disabledDate = (time) => time.getTime() > Date.now() - MS_PER_DAY;
  }

  return pickerOptions;
}

/** 含今天：素材管理、热词分析等 */
export const dateRangePickerOptions = createDateRangePickerOptions();

/** 不含今天：素材统计、广告/VIP 报表等 */
export const dateRangePickerOptionsExcludeToday = createDateRangePickerOptions({ excludeToday: true });
